import React from 'react';
import { Message, Icon } from 'semantic-ui-react';

/**
 * InvalidProfileRequest component for handling invalid profile requests
 * @param {Object} props - Component props
 * @param {string} props.profileType - The requested profile type
 * @param {string} props.message - Custom error message (optional)
 * @returns {JSX.Element} InvalidProfileRequest component
 */
const InvalidProfileRequest = ({ profileType, message }) => {
  const defaultMessage = profileType
    ? `Invalid profile request for type: ${profileType}`
    : 'Invalid profile request';

  return (
    <Message warning icon>
      <Icon name="exclamation triangle" />
      <Message.Content>
        <Message.Header>Profile Request Error</Message.Header>
        <p>{message || defaultMessage}</p>
        <p>Please contact support if this issue persists.</p>
      </Message.Content>
    </Message>
  );
};

export default InvalidProfileRequest;
